import * as api from '@/http'

export const ActionSetEmployees = async ({ commit }) => {
  const employees = await api.http.get('dash/employees').then(
    (response) => response.body,
    (error) => error
  )
  commit('SET_employees', employees)
}

export const ActionUpdatePermissions = async ({ commit }, payload) => {
  const { user_id, permissions } = payload
  const employees = await api.http
    .put(`dash/employees/permission/${user_id}`, { permissions })
    .then((response) => response.body)
  commit('SET_employees', employees)
}

export const ActionUpdateAuthorizations = async ({ commit }, payload) => {
  const { user_id, authorizations } = payload
  const employees = await api.http
    .put(`dash/employees/authorization/${user_id}`, { authorizations })
    .then((response) => response.body)
  commit('SET_employees', employees)
}

export const ActionUpdateStatus = async ({ commit }, payload) => {
  const { user_id, status } = payload
  const employees = await api.http
    .put(`dash/employees/status/${user_id}`, { status })
    .then((response) => response.body)
  commit('SET_employees', employees)
}

export const ActionUpdateEmployee = async ({ commit, dispatch }, payload) => {
  let selected_employee = PrepareEmployeeToCommit(payload)

  const employees = await api.http
    .put(`dash/employees/${selected_employee.id}`, selected_employee)
    .then((response) => response.body)
  dispatch('ActionSetBirthdays')
  commit('SET_employees', employees)
}

export const ActionSetBirthdays = async ({ commit }) => {
  const birthdays = await api.http.get('dash/employees/birthdays').then((response) => response.body)
  commit('SET_birthdays', birthdays)
}

export const ActionSetContactMessageWebSite = async ({ commit }) => {
  //refatorar colocar em utils
  const messages = await api.http
    .get('dash/utils/rh_messages_contact_form')
    .then((response) => response.body)
  commit('SET_contactMessagesWebSite', messages)
}

export const ActionStoreEmployee = async ({ commit }, data) => {
  let new_employee = PrepareEmployeeToCommit(data)

  const employees = await api.http
    .post('dash/employees', new_employee)
    .then((response) => response.body)
  commit('SET_employees', employees)
}

export const ActionStorePaycheckEmployee = async ({ commit }, data) => {
  const paychecks = await api.http
    .post('dash/employees/paycheck', data)
    .then((response) => response.body)
  commit('SET_paychecks', paychecks)
}

export const ActionUpdatePaycheckEmployee = async ({ commit }, payload) => {
  const { paycheck_id, paycheck } = payload
  const paychecks = await api.http
    .post(`dash/employees/paycheck/${paycheck_id}`, paycheck)
    .then((response) => response.body)
  commit('SET_paychecks', paychecks)
}

export const ActionGetPaycheckEmployee = async ({ commit }) => {
  const paycheck = await api.http.get('dash/employees/paycheck').then((response) => response.body)
  commit('SET_paychecks', paycheck)
}

export const ActionDeletePaycheckEmployee = async ({ commit }, paycheck_id) => {
  const paycheck = await api.http
    .delete(`dash/employees/paycheck/${paycheck_id}`)
    .then((response) => response.body)
  commit('SET_paychecks', paycheck)
}

export const ActionSetPaycheckEmployee = async ({ commit }) => {
  const paycheck = await api.http.get('dash/employees/paycheck').then((response) => response.body)
  commit('SET_paychecks', paycheck)
}

export const PrepareEmployeeToCommit = (new_employee) => {
  new_employee.cpf =
    new_employee.cpf.split('-')[0].split('.')[0] +
    new_employee.cpf.split('-')[0].split('.')[1] +
    new_employee.cpf.split('-')[0].split('.')[2] +
    new_employee.cpf.split('-')[1]

  new_employee.mobile_phone = new_employee.mobile_phone.split('(')[1]
  new_employee.mobile_phone =
    new_employee.mobile_phone.split(')')[0] + new_employee.mobile_phone.split(')')[1]

  new_employee.post_code = new_employee.post_code.replace(/-/g, '')

  return new_employee
}

export const ActionSetScales = async ({ commit }) => {
  const scales = await api.http.get('dash/scales/finished').then((response) => response.body)
  commit('SET_scales', scales)
}

export const ActionDownloadScalePDF = async ({}, id) => {
  const pdf = await api.http
    .post(
      `dash/scales/pdf/${id}`,
      {},
      {
        responseType: 'arraybuffer',
      }
    )
    .then((response) => {
      DownloadPdf(response.data)
    })
}

export const ActionSetIncomeTaxes = async ({ commit }) => {
  const income_taxes = await api.http.get('dash/dp/income_tax').then((response) => response.body)
  commit('SET_income_taxes', income_taxes)
}

export const ActionStoreIncomeTaxesIndividual = async ({ commit }, payload) => {
  const income_taxes = await api.http
    .post('dash/dp/income_tax', payload)
    .then((response) => response.body)
  commit('SET_income_taxes', income_taxes)
}

export const ActionDeleteIncomeTax = async ({ commit }, id) => {
  const income_taxes = await api.http
    .delete(`dash/dp/income_tax/${id}`)
    .then((response) => response.body)
  commit('SET_income_taxes', income_taxes)
}

export const ActionDownloadIncomeTaxPDF = async ({}, id) => {
  const pdf = await api.http
    .post(
      `dash/dp/income_tax/${id}`,
      {},
      {
        responseType: 'arraybuffer',
      }
    )
    .then((response) => {
      DownloadPdf(response.data)
    })
}

const DownloadPdf = (data) => {
  try {
    var blob = new Blob([data], { type: 'application/pdf;base64' })
    var blobURL = URL.createObjectURL(blob)
    window.open(blobURL, '_blank')
  } catch (error) {
    console.log(error)
  }
}
